import React, { useState, useEffect } from "react";

import Service from "../../Service/firebase";
import { GENDER_OPTIONS } from "../../constant/categoryGroups";

import "./editsubcategoryform.css";
const EditServiceForm = (props) => {
  const [categories, setCategories] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [groupOptions, setGroupOptions] = useState([]);
  const [vendorCodeError, setVendorCodeError] = useState("");

  useEffect(() => {
    let isSubscribed = true;
    if (isSubscribed) {
      onFetchData();
    }
    return () => {
      isSubscribed = false;
    };
  }, []);

  // When the category changes, update the group options from Firestore
  useEffect(() => {
    const catId = props.service.categoryId;
    if (catId) {
      Service.getServiceGroupsByCategoryId(catId).then((groups) => {
        setGroupOptions(groups);
      });
    }
  }, [props.service.categoryId]);

  const onFetchData = async () => {
    const fetchedCategories = await Service.getAllData("category");
    const fetchedVendors = await Service.getAllData("vendors");

    if (fetchedCategories.length > 0) setCategories(fetchedCategories);
    if (fetchedVendors.length > 0) setVendors(fetchedVendors);
  };

  const handleCategoryChange = async (e) => {
    const categoryId = e.target.value;
    props.onEdit(e);
    const groups = await Service.getServiceGroupsByCategoryId(categoryId);
    setGroupOptions(groups);
  };

  return (
    <div className="ditd_salon_type_formpage">
      <div className="container main_section">
        <div className="topheader">
          <ul>
            <li>
              <i className="fa fa-arrow-circle-o-right fa-2x" aria-hidden="true"></i>
            </li>
            <li>
              <h5>Edit Service</h5>
            </li>
          </ul>
        </div>
        <hr />
        <div className="row">
          <div className="col-sm-8 first_section">
            <form onSubmit={props.handleSubmit}>

              {/* Vendor Code */}
              <div className="form-row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="editVendorCode">Vendor Code</label>
                  <input
                    name="vendorCode"
                    type="text"
                    className="form-control"
                    id="editVendorCode"
                    value={props.vendorCode || ""}
                    onChange={props.onEdit}
                    onBlur={(e) => {
                      const code = e.target.value;
                      if (code && !vendors.find((v) => v.vendorCode === code)) {
                        setVendorCodeError("Vendor code not found");
                      } else {
                        setVendorCodeError("");
                      }
                    }}
                    required
                  />
                  {vendorCodeError && (
                    <small style={{ color: "red" }}>{vendorCodeError}</small>
                  )}
                </div>
              </div>

              {/* Category */}
              <div className="form-row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="editCategoryId">Category</label>
                  <select
                    name="categoryId"
                    id="editCategoryId"
                    className="form-control"
                    value={props.service.categoryId || ""}
                    onChange={handleCategoryChange}
                    required
                  >
                    <option value="">Select Category</option>
                    {categories.map((option) => (
                      <option key={option.categoryId} value={option.categoryId}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Group */}
              {groupOptions.length > 0 && (
                <div className="form-row">
                  <div className="col-md-6 mb-3">
                    <label htmlFor="editGroup">Group</label>
                    <select
                      name="group"
                      id="editGroup"
                      className="form-control"
                      value={props.service.group || ""}
                      onChange={props.onEdit}
                    >
                      <option value="">Select Group</option>
                      {groupOptions.map((g) => (
                        <option key={g} value={g}>{g}</option>
                      ))}
                    </select>
                  </div>
                </div>
              )}

              {/* Service Name */}
              <div className="form-row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="editServiceName">Service Name</label>
                  <input
                    name="serviceName"
                    type="text"
                    className="form-control"
                    id="editServiceName"
                    required
                    value={props.service.serviceName || ""}
                    onChange={props.onEdit}
                  />
                </div>
              </div>

              {/* Gender */}
              <div className="form-row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="editGender">For (Gender)</label>
                  <select
                    name="gender"
                    id="editGender"
                    className="form-control"
                    value={props.service.gender || ""}
                    onChange={props.onEdit}
                    required
                  >
                    <option value="">Select Gender</option>
                    {GENDER_OPTIONS.map((g) => (
                      <option key={g.value} value={g.value}>{g.label}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Price row */}
              <div className="form-row">
                <div className="col-md-3 mb-3">
                  <label htmlFor="editActualPrice">Actual Price (₹)</label>
                  <input
                    name="actualPrice"
                    type="text"
                    className="form-control"
                    id="editActualPrice"
                    value={props.service.actualPrice || ""}
                    onChange={props.onEdit}
                    required
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <label htmlFor="editOfferPrice">Offer Price (₹)</label>
                  <input
                    name="offerPrice"
                    type="text"
                    className="form-control"
                    id="editOfferPrice"
                    value={props.service.offerPrice || ""}
                    onChange={props.onEdit}
                    required
                  />
                </div>
              </div>

              {/* Duration */}
              <div className="form-row">
                <div className="col-md-3 mb-3">
                  <label htmlFor="editServiceTime">Duration (min)</label>
                  <input
                    name="serviceTime"
                    type="text"
                    className="form-control"
                    id="editServiceTime"
                    value={props.service.serviceTime || ""}
                    onChange={props.onEdit}
                    required
                  />
                </div>
              </div>

              {/* Description */}
              <div className="form-row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="editDescription">Description</label>
                  <textarea
                    name="description"
                    className="form-control"
                    id="editDescription"
                    value={props.service.description || ""}
                    onChange={props.onEdit}
                    rows="2"
                  ></textarea>
                </div>
              </div>

              {/* Flags */}
              <div className="form-row">
                <div className="col-md-6 mb-3" style={{ display: "flex", gap: "20px" }}>
                  <label>
                    <input
                      name="isActive"
                      type="checkbox"
                      checked={props.service.isActive || false}
                      onChange={props.onEdit}
                    />{" "}
                    Active
                  </label>
                  <label>
                    <input
                      name="isPackage"
                      type="checkbox"
                      checked={props.service.isPackage || false}
                      onChange={props.onEdit}
                    />{" "}
                    Is Package
                  </label>
                </div>
              </div>

              <button
                className="btn btn-success update_btn"
                type="submit"
                style={{ marginRight: "10px" }}
              >
                Update
              </button>
              <button
                className="btn btn-secondary"
                type="button"
                onClick={props.onCancel}
              >
                Cancel
              </button>
            </form>
          </div>

          <div className="col-sm-4 second_section">
            <div className="profileimage">{props.profileHtmlelEment}</div>
            <div className="btn_section">
              <label htmlFor="editServiceImage" className="selectimage">
                Upload Service Image
              </label>
              <input
                name="image"
                id="editServiceImage"
                type="file"
                onChange={props.onImageChange}
              />
              <button
                type="button"
                className="removebutton"
                onClick={props.onImageRemove}
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditServiceForm;
